var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMediumDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 12.3984C24.5 19.0259 19.1274 24.3984 12.5 24.3984C5.87258 24.3984 0.5 19.0259 0.5 12.3984C0.5 5.77102 5.87258 0.398438 12.5 0.398438C19.1274 0.398438 24.5 5.77102 24.5 12.3984ZM8.52537 17.5784C11.3656 17.5784 13.668 15.2602 13.668 12.4005C13.668 9.54086 11.3656 7.22266 8.52542 7.22266C5.68522 7.22266 3.38281 9.54086 3.38281 12.4005C3.38281 15.2602 5.68522 17.5784 8.52537 17.5784ZM19.3096 12.4014C19.3096 15.0933 18.1583 17.2755 16.7383 17.2755C15.3182 17.2755 14.167 15.0933 14.167 12.4014C14.167 9.70952 15.3182 7.52734 16.7383 7.52734C18.1583 7.52734 19.3096 9.70952 19.3096 12.4014ZM20.7128 16.7691C21.2122 16.7691 21.6171 14.8139 21.6171 12.4021C21.6171 9.99031 21.2122 8.03516 20.7128 8.03516C20.2133 8.03516 19.8085 9.99031 19.8085 12.4021C19.8085 14.8139 20.2133 16.7691 20.7128 16.7691Z",
    fill: "#E3E9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMediumDark);
export default __webpack_public_path__ + "static/media/FooterMediumDark.9ed10a2698ec0ac9bbf826a442b708e8.svg";
export { ForwardRef as ReactComponent };